import { Stack } from '@mui/material';
import { CandidateNavbarUserDropdownMenu } from '../../../UserNavigationMenus/CandidateMenus/CandidateNavbarUserDropdownMenu';
import { CandidateNavBarAuthenticatedViewProps } from 'types/connectTypes';

export const CandidateNavBarAuthenticatedView: React.FC<CandidateNavBarAuthenticatedViewProps> = ({
  user,
  candidateMatches,
}) => {
  return (
    <Stack direction={'row'} gap={1}>
      <CandidateNavbarUserDropdownMenu user={user} candidateMatches={candidateMatches} />
    </Stack>
  );
};
